import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-700 dark:text-gray-300">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        The Village of Hope Child Tracking and Development Monitoring System
        respects and protects the privacy of all children, staff, and system
        users. This system is designed to securely manage and monitor the
        development and wellbeing of children in the Village of Hope Orphanage.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <ul className="list-disc ml-6">
        <li>Child personal information and development records</li>
        <li>Health monitoring and check-up records</li>
        <li>User account information for authorized staff</li>
        <li>Donation records and donor information</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Data Protection</h2>
      <p>
        All information stored in the system is protected using secure
        authentication, encrypted communication, and controlled access
        permissions. Only authorized personnel can access sensitive child
        records.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Use of Information</h2>
      <p>
        Information collected is used solely for monitoring child development,
        managing orphanage operations, generating reports, and improving the
        welfare of children in the Village of Hope.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Confidentiality</h2>
      <p>
        All users of this system are required to maintain confidentiality of the
        data and must not share sensitive information outside authorized
        purposes.
      </p>
    </div>
  );
}